import React from 'react';
import {configStore} from 'app/store/global';
import StreamsAside from 'app/components/streams/streams_aside';
import CupAside from 'app/components/pages/cup/CupAside';
import SurveyStatistics from 'app/components/SurveyStatistics';
import {useAsideStickyTop} from 'app/utils/useAsideStickyTop';
import {checkingPages} from 'app/utils';
import {i18n_t} from 'app/i18n';
import ArticleAside from 'site_version/common/aside/ArticleAside';

const AsideLeft = (): React.ReactElement => {
    const showCup = !window.location.pathname.includes('/cup') && !configStore.isDevelopment;
    const {ref, top} = useAsideStickyTop(true);

    return <aside className="aside aside--left">
        <div ref={ref} className="aside__inner" style={{top}}>
            <StreamsAside/>
            {showCup && <CupAside/>}
            {!checkingPages.isHomePage() && <ArticleAside type="promotions" title={i18n_t('promotions_title')} />}
            <SurveyStatistics/>
        </div>
    </aside>;
};

export default AsideLeft;
